export default __webpack_public_path__ + "static/media/main.86483482.gif";